// This is the webpack entry point
// Refrain from putting actual code in here and just import the modules you need;

import VendorScriptLoader from './utility/vendor-script-loader';
import LazyLoad from './utility/lazy-load';
import AnchorSmoothScroll from './utility/anchor-smooth-scroll';
import HeaderNav from './components/header-nav';
import HorizontalScrollElement from "./utility/horizontal-scroll-element";
// import NavLinkToggler from './utility/nav-link-toggler';

// Temporary usage until we set up Borlabs v3
// import './fonts';

// Google Maps :: when loading the Google Maps js API a callback is required to be passed, but since
// we are already firing an event when the script is loaded, there's no need for this callback.
// We define it just to avoid the console error.
window.initMap = () => { };

/**
 * Code-splitting :: Blocks
 *
 * Manages blocks that should load dynamically (only when they exist in the DOM)
 * using Webpack's code-splitting feature.
 */
function registerBlocks() {
  if (document.querySelector('.js-map')) {
    // Loads component only after vendor file is loaded
    document.addEventListener('google-maps:loaded', () => {
      // alert('Google Maps loaded');
    });

    VendorScriptLoader.outputGoogleMapsScriptTag();
  }

  if (document.getElementById('feed')) {
    // Loads component only after vendor files are loaded
    document.addEventListener('multiple-vendors:loaded', () => {
      import('~scripts/blocks/feed');
    });

    VendorScriptLoader.outputVendorScriptTags(['vendor-vue', 'vendor-pinia']);
  }

  if (document.querySelector('.wp-block-quote')) {
    import('~styles/blocks/wp/details.scss');
  }

  if (document.querySelector('.wp-block-separator')) {
    import('~styles/blocks/wp/separator.scss');
  }

  if (document.querySelector('.wp-block-accordion')) {
    import('~styles/blocks/wp/accordion.scss');
  }

  if (document.querySelector('.wp-block-columns')) {
    import ('~styles/blocks/wp/columns.scss');
  }

  if (document.querySelector('.js-logos-block')) {
    import('~scripts/blocks/logos');
  }

  if (document.querySelector('.js-call-to-action-block')) {
    import('~scripts/blocks/call-to-action');
  }

  if (document.querySelector('.js-tile-block')) {
    import('~scripts/blocks/tile');
  }

  if (document.querySelector('.js-pullquote-block')) {
    import('~scripts/blocks/pullquote');
  }

  if (document.querySelector('.js-promo-block')) {
    import('~scripts/blocks/promo');
  }

  // if (document.querySelector('.js-header-block')) {
  //   import('~scripts/blocks/header');
  // }

  if (document.querySelector('.js-image-video-block')) {
    import('~scripts/blocks/image-video');
  }

  if (document.querySelector('.js-single-page-block')) {
    import('~scripts/blocks/single-page');
  }

  if ( document.querySelector('.js-post-carousel-block') ) {
    import('~styles/blocks/post-carousel/index.scss');
  }

  // TODO - there's an issue with VendorScriptLoader when loading different components, on the same page, using similar vendor files. This causes a race condition and the last component to load will error out. To enable this demo component you will need to disable Feed component, if in use.
  // if ( document.getElementById('lottie-vue-example') ) {
  //   // Loads component only after vendor files are loaded
  //   document.addEventListener('multiple-vendors:loaded', () => {
  //     import('~scripts/blocks/vue-lottie-example');
  //   });
  //
  //   VendorScriptLoader.outputVendorScriptTags(['vendor-vue']);
  // }
}

/**
 * Code-splitting :: Components
 *
 * Manages components that should load dynamically (only when they exist in the DOM)
 * using Webpack's code-splitting feature.
 */
function registerComponents() {
  // if ( document.querySelector('.js-example-component') ) {
  //   // Loads component only after vendor file is loaded
  //   document.addEventListener('vendor-vue:loaded', () => {
  //     import('~scripts/components/example');
  //   });
  //
  //   VendorScriptLoader.outputVendorScriptTag('vendor-vue');
  // }

  if (document.querySelector('.js-post-carousel')) {
    import('~scripts/components/carousels/post-carousel').then(component => {
      component.default.init();
    });
  }

  if (document.querySelector('.js-example-component')) {
    import('~scripts/components/example');
  }

  if (document.querySelector('.js-booking-form')) {
    import('~scripts/components/training-course/booking-form');
  }

  // TODO - there's an issue with VendorScriptLoader when loading different components, on the same page, using similar vendor files. This causes a race condition and the last component to load will error out. To enable this demo component you will need to disable Feed component, if in use.
  // if ( document.getElementById('js-vue-demo-components') ) {
  //   // Loads component only after vendor files are loaded
  //   document.addEventListener('vendor-vue:loaded', () => {
  //     import('~scripts/components/vue-demo-components');
  //   });

  //   VendorScriptLoader.outputVendorScriptTag('vendor-vue');
  // }

  // Search Overlay
  // if ( document.querySelector('.js-search-overlay') ) {
  //   import('~scripts/components/search-overlay').then(component => {
  //     component.default.init();
  //   });
  // }

  // Form :: custom choice fields
  if (document.querySelectorAll('.form-style select').length) {
    // Loads component only after vendor file is loaded
    document.addEventListener('vendor-choices:loaded', () => {
      import('~scripts/components/form/form-custom-select-styles').then(component => {
        component.default.init('.form-style');
      });
    });

    VendorScriptLoader.outputVendorScriptTag('vendor-choices');
  }

  // Form :: field validation feedback
  if (document.querySelectorAll('.form-style').length) {
    import('~scripts/components/form/form-field-validation-feedback').then(component => {
      const FormFieldValidationFeedback = component.default;
      FormFieldValidationFeedback.init('.form-style');
    });
  }

  // Generic form (i.e. search form)
  if (document.querySelectorAll('.js-generic-form  select').length) {
    import('~scripts/components/form/generic-form-custom-select-styles').then(component => {
      component.default.init('.js-generic-form');
    });
  }

  // Wordpress pagination
  if (document.querySelector('.js-wp-pagination')) {
    import('~styles/components/wp-pagination/index.scss');
  }

  if (document.querySelector('.js-video-autoplay')) {
    import('~scripts/components/video/video-autoplay').then(component => {
      component.default.init();
    });
  }

  if (document.querySelector('.js-lottie-file')) {
    // Loads component only after vendor file is loaded
    document.addEventListener('vendor-lottie-player:loaded', () => {
      import('~scripts/components/lottie-file');
    });

    VendorScriptLoader.outputVendorScriptTag('vendor-lottie-player');
  }

  // Custom horizontal scrollbar
  if (document.querySelector('.js-horizontal-scrollbar')) {
    import('~scripts/components/custom-scrollbar/horizontal-scrollbar').then(component => {
      const HorizontalScrollbar = component.default;

      // Adjusts custom scrollbar's width so that it corresponds to the difference in widths
      // between the scrollable content and the scrollbar area.
      // This function will have 1 argument: 'instance'
      const calculateScrollbarWidthOffsetFn = () => {
        // const scrollbarContainerRightPos = instance._customScrollbarContainerEl.getBoundingClientRect().right;
        // const viewportWidth = window.innerWidth;
        //
        // // Calculate the space between the scrollbar's right edge and the viewport's right edge
        // const space = Math.floor(viewportWidth - scrollbarContainerRightPos);
        //
        // return space / 2;

        return 0;
      };

      document.querySelectorAll('.js-horizontal-scrollbar').forEach(node => {
        new HorizontalScrollbar(node, calculateScrollbarWidthOffsetFn);
      });
    });
  }

  // if ( document.querySelector('.js-simple-accordion') ) {
  //   import('~scripts/components/accordion/simple-accordion').then(component => {
  //     const SimpleAccordion = component.default;
  //
  //     document.querySelectorAll('.js-simple-accordion').forEach(node => {
  //       new SimpleAccordion(node);
  //     });
  //   });
  // }


  if (document.querySelector('.js-dev-styles-guide')) {
    import('~styles/components/dev-styles-guide/index.scss');
  }
}


/**
 * DOMContentLoaded events should be listened to on this file only.
 */
document.addEventListener('DOMContentLoaded', registerBlocks);
document.addEventListener('DOMContentLoaded', registerComponents);

/**
 * Load common components here
 */
document.addEventListener('DOMContentLoaded', () => {
  // Example
  // // Initiates Header Nav Menu
  HeaderNav.init();

  // Applies lazy-loading to images on the page
  LazyLoad.init();

  // Initiates Anchor Smooth Scroll utility
  AnchorSmoothScroll.init();

  // Navigation link toggler for current active item
  // NavLinkToggler.init();

  /**
  * Adjustments for horizontal scrollable elements
  */
  document.querySelectorAll('.js-hscroll-element').forEach(node => {
    new HorizontalScrollElement(node);
  });

});
